import React from 'react';
import get from 'lodash/get';
import PropTypes from 'prop-types';
import Avatar from '../../components/Avatar';
import Grid from '../../components/Grid';
import './styles.css';

const Contact = ({ contact, phone }) => {
  const fullName = get(contact, 'name');
  const title = get(contact, 'field_job_position');
  const image = get(contact, 'field_profile_picture_file_url');
  const email = get(contact, 'field_contact_work');

  return (
    <Grid>
      <Grid.Row>
        <Grid.Column verticalAlign="middle" width={8}>
          <Avatar
            user
            image={image}
            icon="user"
            fullName={fullName}
          />
          <div styleName="name">
            {fullName}
          </div>
          <div styleName="title">
            {title}
          </div>
        </Grid.Column>
        <Grid.Column width={8}>
          <div styleName="email" className="emailText">{email}</div>
          <div styleName="phone">{phone}</div>
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
};

Contact.propTypes = {
  contact: PropTypes.object,
  phone: PropTypes.string,
};

export default Contact;
